import { z } from 'zod';

const resetPasswordSchema = z
   .object({
      password: z
         .string()
         .min(6, 'Password must be at least 6 characters')
         .regex(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).*$/,
            'Password must include at least one uppercase letter, one number, and one special character',
         ),
      confirmPassword: z.string().min(6, 'Password must be at least 6 characters'),
   })
   .refine(data => data.password === data.confirmPassword, {
      path: ['confirmPassword'],
      message: 'Passwords do not match',
   });

type TResetPassword = z.infer<typeof resetPasswordSchema>;

export { resetPasswordSchema };
export type { TResetPassword };
